<template>
<a :href="item.clickUrl" :data-scp="item.scpCD">
	<div class="pos-r bg-white overflow-h">	
		<div class="pos-r">
			<div v-bind:style="{'padding-top':((item.height/item.width)||1).toFixed(2)*100+'%'}"></div>
			<img :src="item.imageUrl?item.imageUrl:defaultImg.default" @error="errImg(item, 'imageUrl')" style="position:absolute;top:0;left:0;right:0;bottom:0">
		</div>
		<div class="sajiao_line pos-a bottom0 left0" v-if="item.isCrowd&&(item.crowdState!==2)">
			<div class="pos-r overflow-h">
				<div class="bg-red pos-a top0" :style="'right:'+parseInt(100-item.progress*100)+'%'" style="right:44%;"></div>
				<object>
					<a :href="'/fittingShow/sajiaoxiangqing.html?id='+item.crowdItemId">
						<span class="pos-a text-center text-white fs-11 top0 left0" v-text="'撒娇ing '+parseInt(item.progress*100)+'%'"></span>
					</a>
				</object>
			</div>
		</div>
		<div class="paddingh10 sajiao-icon pos-a fs-10 top20 right0" :class="item.flowerCount>0?'text-red':'text-white'">
			<span>
				<i class="fs-14 marginr10 float-left" :class="item.flowerCount>0?'icon-xiaohuafill':'icon-xianhua'"></i>
			</span>
			<span class="float-left" v-text="item.flowerCount>0?item.flowerCount:'献花'"></span>
		</div>
		<div class="pos-a paddingh40 bg-orange text-white fs-10 sajiao_recommendTag" v-if="item.recommendTag">推荐</div>
	</div>
	<div class="bg-white paddingv20 paddingh10 marginb10">
		<div class="flex-container">
			<div class="flex-container">
				<div class="img-container round">
					<img :src="item.logoImageUrl?item.logoImageUrl:defaultImg.logoImageUrl"
						 @error="errImg(item, 'logoImageUrl')"
						 alt="" width="24" height="24" class="">
				</div>
				<div class="fs-10 text-darker marginl10" v-text="item.nickName"></div>
			</div>
			<!--<span class="dis-i sajiao_button bg-red text-white fs-11 lh-20 text-center"-->
				  <!--v-if="item.friendState==0"-->
				  <!--@click.prevent.stop="follow(item.nickName,item.memberId,item)">约TA</span>-->
			<!--<span class="dis-i sajiao_button bg-red text-white fs-11 lh-20 text-center"-->
				  <!--v-if="item.friendState==1">放电中</span>-->
			<span class="dis-i sajiao_button bg-red text-white fs-11 lh-20 text-center"
				  v-if="item.memberId!=memberId"
				  @click.prevent.stop="chat(item.memberId)" data-scp="showList.chat">聊聊</span>
		</div>
		<div class="text-dark fs-10 margint10" v-text="item.topic"></div>
		<div class="text-light fs-10 margint10">
			<i class="icon-locationfill fs-12 text-lighter"></i>
			<span v-text="item.address"></span>
		</div>
	</div>
</a>
</template>
<style lang="scss">
.sajiao_button{
	height:28px;
	border-radius: 14px;
	-webkit-border-radius: 14px;
	-moz-border-radius: 14px;
	-o-border-radius: 14px;
}
.sajiao_line{
	width:100%;
	height:14px;
}
.sajiao_line>div{
	background:rgba(0,0,0,.6);
	height:100%;
}
.sajiao_line>div div,.sajiao_line>div span{
	width:100%;
	height:100%;
	border-bottom-right-radius: 7px;
	-webkit-border-bottom-right-radius: 7px;
	-moz-border-bottom-right-radius: 7px;
	-o-border-bottom-right-radius: 7px;
	border-top-right-radius: 7px;
	-webkit-border-top-right-radius: 7px;
	-moz-border-top-right-radius: 7px;
	-o-border-top-right-radius: 7px;
}
.sajiao-icon{
	background:rgba(0,0,0,.6);
	height:20px;
	padding-top:3px;
	padding-bottom:3px;
	border-bottom-left-radius: 10px;
	-webkit-border-bottom-left-radius: 10px;
	-moz-border-bottom-left-radius: 10px;
	-o-border-bottom-left-radius: 10px;
	border-top-left-radius: 10px;
	-webkit-border-top-left-radius: 10px;
	-moz-border-top-left-radius: 10px;
	-o-border-top-left-radius: 10px;
}
.sajiao_button{
	height:20px;
	border-radius: 10px;
	-webkit-border-radius: 10px;
	-moz-border-radius: 10px;
	-o-border-radius: 10px;
	min-width:50px;
}
.sajiao_recommendTag{
	top: 0;
	left: 0;
	-webkit-transform: translate(-25%, 50%) rotate(-45deg);
	transform: translate(-25%, 50%) rotate(-45deg);
	-webkit-transform-origin: center center;
	transform-origin: center center;
}
</style>
<script>
import maple from 'maple';
import {defaultImg, errImg} from '../default.js';

var memberId = maple.cookie('memberId') || '';

export default {
	props: {
		item: {
			type: Object
			, default: {}
		}
		, defaultImg: {
			type: Object
			, default: defaultImg
		}
	}
	, data(){
		return {
			memberId
		};
	}
	, methods: {
		errImg: errImg
		, follow: function(nickName, id, item){
			this.$dispatch('followEvent', nickName, id, item);
		}
		, chat: function(id){
			this.$dispatch('chatEvent', id, 'showList.chat');
		}
	}
}
</script>